import { init, InitFunctionOptions } from './bootstrap';
import hostAppProps from './mocks/data/host-app';

const getLocalStoragedHostAppProps = (): Partial<InitFunctionOptions> => {
  const storedHostAppProps = localStorage.getItem('HOST_APP_PROPS');

  if (!storedHostAppProps) return {};

  try {
    const parsed: unknown = JSON.parse(storedHostAppProps);

    if (typeof parsed !== 'object' || parsed === null) return {};

    return parsed as Partial<InitFunctionOptions>;
  } catch {
    return {};
  }
};

const getDevHostAppProps = (): InitFunctionOptions => {
  const storedHostAppProps = getLocalStoragedHostAppProps();

  return {
    ...hostAppProps,
    ...storedHostAppProps,
    data: {
      ...hostAppProps.data,
      ...storedHostAppProps.data,
    },
    callbacks: {
      ...hostAppProps.callbacks,
      ...storedHostAppProps.callbacks,
    },
  };
};

const startDevMode = () => {
  // If we are in development and in isolation,
  // call init immediately
  if (process.env.NODE_ENV === 'development') {
    if (module.hot) {
      module.hot.accept();
    }

    const devRoot = document.querySelector(`#${process.env.REACT_APP_ROOT_ID}`);
    if (devRoot) {
      // enable mock mode
      if (process.env.REACT_APP_MOCK) {
        const { worker } = require('./mocks/browser');
        worker.start();
      }

      init(getDevHostAppProps());
    }
  }
};

export default startDevMode;
